import { PATH_DASHBOARD } from '../../../routes/paths';
import Iconify from '../../../components/iconify';

// ----------------------------------------------------------------------

const icon = (name) => <Iconify icon={name} />;

const getNavConfig = () => [
    {
        subheader: 'Змагання',
        items: [
            {
                title: 'Мої змагання',
                path: PATH_DASHBOARD.start,
                icon: icon('qlementine-icons:items-grid-16'),
            },
        ],
    },
];

export default getNavConfig;
